import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
} from 'react';

import {useNavigate} from 'react-router';

import {KYC_IDV_DOCS_EVENTS} from '@/app/auth/events/KycIdvDocsEvents';
import {useKycRepository} from '@/dataSource/src/api/kyc/useRepository';

import {useTrackers} from './trackers';

type ViewModelContextType = {
  onSubmitForm: () => void;
};

const ViewModelContext = createContext<ViewModelContextType | undefined>(
  undefined,
);

export function ViewModelProvider({children}: {children: ReactNode}) {
  const navigate = useNavigate();
  const {handlePostDocsSubmitted} = useKycRepository();
  const {trackIdvDocs} = useTrackers();

  useEffect(() => {
    trackIdvDocs(KYC_IDV_DOCS_EVENTS.VIEW_KYC_IN_REVIEW_IDV_DOCS_PAGE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmitForm = useCallback(async () => {
    await handlePostDocsSubmitted();
    setTimeout(() => {
      navigate('/onboarding/your-info-is-in-review?previousScreen=idv-docs');
    }, 100);
  }, [handlePostDocsSubmitted, navigate]);

  return (
    <ViewModelContext.Provider value={{onSubmitForm}}>
      {children}
    </ViewModelContext.Provider>
  );
}

export function useViewModelProvider() {
  const context = useContext(ViewModelContext);
  if (context === undefined) {
    throw new Error('Kyc In Rewiew Idv Docs ViewModelContext is undefined');
  }
  return context;
}
